import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  BankRuleApplication, BankRuleHitStat,
  BankRule, BankRuleApplyItem, BankRuleApplyResult, BankRulePreview, BankRuleRequest, BankRuleTestResult,
  RuleKindInfo,
} from '../interfaces/bank/bankRule.interface';

export const BankRuleService = {
  fields: async (): Promise<RuleKindInfo> => (await axios.get(ENDPOINTS.BANK_RULES.FIELDS)).data,
  list: async (institutionId: string, params?: { bankAccountId?: string; active?: boolean; search?: string }): Promise<BankRule[]> =>
    (await axios.get(ENDPOINTS.BANK_RULES.LIST(institutionId), { params })).data,
  get: async (institutionId: string, ruleId: string): Promise<BankRule> =>
    (await axios.get(ENDPOINTS.BANK_RULES.ONE(institutionId, ruleId))).data,
  create: async (institutionId: string, dto: BankRuleRequest): Promise<BankRule> =>
    (await axios.post(ENDPOINTS.BANK_RULES.LIST(institutionId), dto)).data,
  update: async (institutionId: string, ruleId: string, dto: BankRuleRequest): Promise<BankRule> =>
    (await axios.put(ENDPOINTS.BANK_RULES.ONE(institutionId, ruleId), dto)).data,
  setActive: async (institutionId: string, ruleId: string, active: boolean): Promise<BankRule> =>
    (await axios.post(active ? ENDPOINTS.BANK_RULES.ACTIVATE(institutionId, ruleId) : ENDPOINTS.BANK_RULES.DEACTIVATE(institutionId, ruleId))).data,
  reorder: async (institutionId: string, ruleIds: string[]): Promise<BankRule[]> =>
    (await axios.put(ENDPOINTS.BANK_RULES.ORDER(institutionId), { ruleIds })).data,
  remove: async (institutionId: string, ruleId: string): Promise<void> => {
    await axios.delete(ENDPOINTS.BANK_RULES.ONE(institutionId, ruleId));
  },
  test: async (institutionId: string, dto: BankRuleRequest): Promise<BankRuleTestResult> =>
    (await axios.post(ENDPOINTS.BANK_RULES.TEST(institutionId), dto)).data,
  preview: async (reconciliationId: string): Promise<BankRulePreview> =>
    (await axios.get(ENDPOINTS.BANK_RULES.PREVIEW(reconciliationId))).data,
  apply: async (reconciliationId: string, items: BankRuleApplyItem[]): Promise<BankRuleApplyResult> =>
    (await axios.post(ENDPOINTS.BANK_RULES.APPLY(reconciliationId), { items })).data,
  // ---- FW-4B ----
  applications: async (reconciliationId: string): Promise<BankRuleApplication[]> =>
    (await axios.get(ENDPOINTS.BANK_RULES.APPLICATIONS(reconciliationId))).data,
  hitStats: async (institutionId: string, months = 6): Promise<BankRuleHitStat[]> =>
    (await axios.get(ENDPOINTS.BANK_RULES.HIT_STATS(institutionId), { params: { months } })).data,
  // ---- end FW-4B ----
};
